import React, { useEffect, useState, useRef } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import TreeWithRadioButton from '@pages/common/table_tree/table-tree-with-radio-button';
import { getTCMAllModuleTreeReq, getTCMSingleModuleTreeReq } from '@api/api_services';
import { CommonLoader } from '@pages/common/common-loader';
import { createScript } from '@pages/test-development/script/modules/module/utils/script-create-api';
import { useHistory } from 'react-router-dom';

const ExistingAutomationScript = (props) => {
  let history = useHistory();
  const [selectedScript, setSelectedScript] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [treeData, setTreeData] = useState([]);
  const [manualDataExist, setManualDataExist] = useState(false);

  const totalModCount = useRef(0);
  let initialValues = {
    scriptName: '',
  };
  const validationSchema = yup.object({
    scriptName: yup.string().required('Script Name is required'),
  });

  const onSubmit = async (values) => {
    const modifiedScriptName = values?.scriptName?.split(' - ').slice(1).join(' - ');
    if (values) {
      if (values) {
        const requestBody = {
          name: modifiedScriptName,
          scriptType: selectedScript.data.scriptType,
          desc: selectedScript.data.desc,
          parentId: selectedScript.data.parentId,
          parentName: selectedScript.data.parentName,
          executionOrder: selectedScript.data.executionOrder,
          hierarchy: selectedScript.data.hierarchy,
          testCaseType: 'Automation',
        };
        await createScript(requestBody, 'auto', history, props.MyAlert, selectedScript.data.testCaseType);
        props.closeModal(false);
      }
    }
  };
  const formikDetails = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });
  const treeNodeSelected = ([data]) => {
    if (!data) {
      formikDetails.setFieldValue('scriptName', '');
      setSelectedScript();
    } else if (data && data.data.key) {
      setSelectedScript(data);
      formikDetails.setFieldValue('scriptName', data.data.title);
    }
  };

  const checkManualTcExist = (chilArray) => {
    if (chilArray?.length) {
      let tempArray = chilArray;
      tempArray.map((obj) => {
        if (obj.children) {
          checkManualTcExist(obj.children);
        } else {
          if (obj?.type === 'Script') {
            totalModCount.current++;
          }
        }
      });
    }
  };

  const getScripts = async () => {
    try {
      let response;
      if (props.moduleIdForAdd || props.individualTreeId) {
        const id = props.moduleIdForAdd ? props.moduleIdForAdd : props.individualTreeId;
        response = await getTCMSingleModuleTreeReq(id, 'manual');
      } else {
        response = await getTCMAllModuleTreeReq('manual');
      }
      if (response?.data?.responseObject?.moduleTree) {
        let tempArray = response?.data.responseObject.moduleTree[0].children;
        if (tempArray?.length) {
          checkManualTcExist(tempArray);
          if (totalModCount.current > 0) {
            setTreeData([...response?.data?.responseObject?.moduleTree]);
            setManualDataExist(true);
          } else {
            response.data.responseObject.moduleTree[0].children = [];
            setTreeData([...response?.data?.responseObject?.moduleTree]);
            setManualDataExist(false);
          }
        }
      } else {
        setTreeData([]);
      }
      setIsLoading(false);
    } catch (err) {
      console.error('GET_MANUAL_SCRIPTS : ', err);
    }
  };

  useEffect(() => {
    getScripts();
  }, []);

  return (
    <form id="existingScriptForm" onSubmit={formikDetails.handleSubmit}>
      <div className="mt-3 grid gap-4">
        <div className="parent-module-field-test-dev">
          <label
            htmlFor="scriptName"
            className={
              formikDetails.errors.scriptName && formikDetails.touched.scriptName
                ? 'text-xs text-red-500'
                : 'input-filed-label-style-common'
            }
          >
            <span className="text-red-400">&#42;</span>Select Test Case
          </label>
          <TreeWithRadioButton
            hideRootRadioBtn={true}
            individualTree={props.moduleIdForAdd || props.individualTreeId ? true : false}
            disableRootRadioButton={true}
            defaultDisabled={[{ key: 'folder', value: true }]}
            data={treeData}
            hideElements={false}
            hideElementsBtn={false}
            placeholder={''}
            nodeSelected={treeNodeSelected.bind(this)}
            buttonLabel="Test Case"
            dataExist={manualDataExist}
            noDataMsg="No manual test cases are available"
          />
          {formikDetails.errors.scriptName && formikDetails.touched.scriptName ? (
            <div className="text-red-500 text-xs md:mt-1">{formikDetails.errors.scriptName}</div>
          ) : null}
        </div>
      </div>
    </form>
  );
};

export default ExistingAutomationScript;
